import React from 'react';
import Select, { Props as ReactSelectProps } from 'react-select';

export interface GuiSelectProps extends ReactSelectProps {
  value: any;
  onChange: (value: any, action: any) => void;
  error?: boolean;
}

const GuiSelect = (props: GuiSelectProps) => {
  const { options, onChange, isMulti, value, className, error = false, styles } = props;

  const customStyles = {
    multiValueLabel: (base, state) => {
      return state.data.isFixed
        ? { ...base, paddingRight: 6 }
        : base;
    },
    multiValue: (css) => {
      return {
        ...css,
        borderRadius: "12px",
      };
    },
    multiValueRemove: (base, state) => {
      return state.data.isFixed ? { ...base, display: 'none' } : base;
    },
  };

  const handleChange = (selectedOpts, action) => {
    let val = selectedOpts;

    // eslint-disable-next-line default-case
    switch (action.action) {
      case 'remove-value':
      case 'pop-value':
        if (action.removedValue.isFixed) {
          return;
        }
        break;
      case 'clear':
        val = options.filter((v: any) => v.isFixed);
        // eslint-disable-next-line no-param-reassign
        action.removedValues = action.removedValues.filter((v: any) => !v.isFixed);
        break;
    }

    if (val) {
      val = isMulti ? val.map((opt) => opt.value) : val.value;
    }

    onChange(val, action);
  }

  const getValue = (values) => {
    if (!values) {
      return null;
    }

    if (!isMulti) {
      // @ts-ignore
      return options.find((opt) => opt.value === values);
    }

    // @ts-ignore
    return options.filter((opt) => values.includes(opt.value));
  }
  return (
      <Select
        {...props}
        components={{
          IndicatorSeparator: null,
        }}
        onChange={handleChange}
        value={getValue(value)}
        className={`${className} custom-react-select ${error && 'custom-react-select-is-invalid'}`}
        classNamePrefix="custom-rs"
        isClearable={options.some((v: any) => !v.isFixed)}
        styles={{
          ...customStyles,
          ...styles
        }}
      />
  );
};

export default GuiSelect;
